import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { deleteRoute } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useDeleteRoute = (
  id: number,
  options: UseMutationOptions<void, unknown, void, unknown>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      extractData(deleteRoute({ path: { id } })).then(() => undefined),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['routes'],
      });
      options.onSuccess?.(...args);
    },
  });
};
